import { render, staticRenderFns } from "./malware.vue?vue&type=template&id=611b7816&"
import script from "./malware.vue?vue&type=script&lang=js&"
export * from "./malware.vue?vue&type=script&lang=js&"
import style0 from "./malware.vue?vue&type=style&index=0&id=611b7816&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports